import { useTranslation } from "react-i18next";
import AutoCompletation from "../../../components/Common/AutoCompletation";
import React, { useRef, useState } from "react"
import { FormGroup } from 'react-bootstrap'
import InventoryMedicationService from "../../../api/Inventory/InventoryMedicationService";
import { CustomDate } from "../../../components/CustomControls/CustomDateTime";
import { ErrorMessage } from "../../../components/Notifications/Notifications";
import { useFormModal } from "../../../components/Modals/formModal.js/FormModal";
import ReleaseList from "./ReleaseList";
import { Add, Remove } from "../../../components/Icons/Icons";
import { Tooltip } from "../../../components/Utils/Tooltips";
import GroupedReleaseStockList from "./GroupedReleaseStockList";
import { buildMedicationLabel, isDispenseAddEnabled } from "./inventoryFormRules";
import { QuantityInput } from "./QuantityInput";

export default function KitDispenseForm({ assignmentType, assignId, handleSubmit, disabled = false }) {
    const { t } = useTranslation();
    const expirationDateRef = useRef();
    const expirationDateInputRef = useRef();
    const quantityRef = useRef();
    const medicationRef = useRef();
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedRelease, setSelectedRelease] = useState(null);
    const [selectedKit, setSelectedKit] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [ReleaseModal, ReleaseActions] = useFormModal({ FormContent: ReleaseList })
    const [StockModal, StockActions] = useFormModal({ FormContent: GroupedReleaseStockList })

    const fetchItems = async (term) => {
        const result = await InventoryMedicationService.Find({ term: term, protocolId: assignId, onlyLocal: true, pageSize: 100 })
        return result.Value
    }

    const handleShowReleaseModal = async () => {
        await ReleaseActions.Show({
            title: t('inventory.commons.lotNumber'),
            onConfirmation: (selected) => setSelectedRelease(selected),
            initValue: { itemId: selectedItem.inventoryItemId, assignmentType: assignmentType, assignId: assignId, includeExpired: false }
        })
    }

    const handleShowReleaseStockModal = async () => {
        await StockActions.Show({
            title: t('inventory.commons.stock'),
            onConfirmation: (selected) => setSelectedKit(selected),
            initValue: {
                itemId: selectedItem.inventoryItemId,
                releaseId: selectedRelease.id,
                assignmentType: assignmentType,
                assignId: assignId
            }
        })
    }

    const curringSelected = (callback) => {
        return (selected) => {
            if (selected != null && selected.length > 0) callback(selected[0])
            else callback(null)
        }
    }

    function isFormValid() {
        return isDispenseAddEnabled({
            hasItem: selectedItem !== null,
            hasRelease: selectedRelease !== null,
            hasKit: selectedKit !== null,
            quantity: quantity,
            availableStock: selectedKit?.quantity
        })
    }
    function handleItemClean() {
        setSelectedItem(null)
        setSelectedRelease(null)
        setSelectedKit(null)
        setQuantity(1)
        medicationRef.current.clear()
    }

    function handleFormSubmit(e) {
        e.preventDefault();

        if (!isFormValid() && handleSubmit !== null) return

        if (selectedKit.quantity < quantity) {
            ErrorMessage(t('inventory.dispense.errors.cannotOvercomeTheStockQuantity'))
            return;
        }

        handleSubmit({
            item: selectedItem,
            release: selectedRelease,
            assignment: selectedKit.assignment,
            quantity: quantity,
            availableQuantity: selectedKit.quantity
        })
        handleItemClean()
        medicationRef.current.focus()
    }

    const onCleanSelectedRelease = () => {
        setSelectedRelease(null)
        setSelectedKit(null)
    }

    return (<>
        <form onSubmit={handleFormSubmit} autoComplete="off" >
            <div className='input-group-container'>
                <FormGroup style={{ width: "100%" }}>
                    <AutoCompletation
                        id={'medication'}
                        ref={medicationRef}
                        labelKey={(option) => buildMedicationLabel(option)}  
                        disabled={disabled}
                        placeholder={t('inventory.dispense.findMedication')}
                        fetchOptions={fetchItems}
                        onChange={curringSelected(setSelectedItem)}
                    />
                </FormGroup>
            </div>
            <hr />

            {selectedRelease == null && <div className='input-group-container'>
                <FormGroup style={{ width: "100%" }}>
                    <button className="btn btn-primary" disabled={disabled || selectedItem == null} onClick={_ => handleShowReleaseModal()}>
                        <Tooltip>
                            <Add /> {t('inventory.dispense.selectLotNumber')}
                        </Tooltip>
                    </button>
                </FormGroup>
            </div>
                || <div className='input-group-container'>
                    <FormGroup style={{ width: "100%" }}>
                        <input disabled={true} value={selectedRelease?.lotNumber} className="rbt-input-main form-control rbt-input" />
                    </FormGroup>

                    <FormGroup style={{ width: "100%" }} >
                        <CustomDate
                            dateRef={expirationDateRef}
                            inputRef={expirationDateInputRef}
                            name={`expirationDate`}
                            onChange={() => { }}
                            onBlur={() => { }}
                            value={selectedRelease?.expirationDate ?? null}
                            defaulValue={null}
                            dateFormat="DD/MM/YYYY"
                            disabled={true}
                            inputProps={{ placeholder: t('commons.expirationDate') }}
                        />
                    </FormGroup>

                    <FormGroup style={{ width: "100%" }}>
                        <button className="btn btn-danger" disabled={disabled || selectedRelease == null} onClick={onCleanSelectedRelease}>
                            <Tooltip tooltip={t('commons.clear')} id={"tooltipedit-limpiarpaciente"}>
                                <span aria-hidden="true"><Remove /></span>
                            </Tooltip>
                        </button>
                    </FormGroup>
                </div>}
            <hr />

            {selectedKit == null && <div className='input-group-container'>
                <FormGroup style={{ width: "25%" }}>
                    <button className="btn btn-primary" disabled={disabled || selectedRelease == null} onClick={_ => handleShowReleaseStockModal()}>
                        <Tooltip tooltip={'seleccionar stock'}>
                            <Add />
                        </Tooltip>
                    </button>
                </FormGroup>
                <QuantityInput ref={quantityRef}
                    value={quantity}
                    onChange={setQuantity}
                    max={selectedKit?.quantity}
                    disabled={disabled || selectedKit == null}
                    placeholder={t('inventory.dispense.quantity')}
                    style={{ width: "50%" }} />
            </div>
                || <div className='input-group-container'>
                    <FormGroup style={{ width: "25%" }}>
                        <input disabled={true} value={selectedKit?.assignment?.kitNumber
                            ?? ' - '} className="rbt-input-main form-control rbt-input" />
                    </FormGroup>

                    <FormGroup>
                        <button className="btn btn-danger" disabled={selectedRelease == null} onClick={() => setSelectedKit(null)}>
                            <Tooltip tooltip={t('commons.clear')} id={"tooltipedit-limpiarpaciente"}>
                                <span aria-hidden="true"><Remove /></span>
                            </Tooltip>
                        </button>
                    </FormGroup>
                    <QuantityInput ref={quantityRef}
                        value={quantity}
                        onChange={setQuantity}
                        max={selectedKit?.quantity}
                        disabled={disabled || selectedKit == null}
                        placeholder={t('inventory.dispense.quantity')}
                        style={{ width: "50%" }} />
                </div>}
            <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'end' }} >
                <div style={{ alignSelf: 'self-end', marginTop: '1rem' }}>
                    <button type="submit" className='btn btn-success' disabled={disabled || !isFormValid()}>{t('buttons.add')}</button>
                </div>
            </div>
            <ReleaseModal />
            <StockModal />
        </form >
    </>)
}